import React from "react";
import { useState } from "@vrf/fr-vrf-core-react";
import { ProjectDetailPageContext, ProjectDetailPageInitialState } from ".";

export const ProjectDetailPageStateProvider = ({ children }: any) => {
  const [pageState, setPageState] = useState(ProjectDetailPageInitialState);
  const context = {
    pageState: pageState,
    setPageState: setPageState,
  };
  return (
    <ProjectDetailPageContext.Provider value={context}>
      {children}
    </ProjectDetailPageContext.Provider>
  );
};
